import { render, staticRenderFns } from "./safeRecord.vue?vue&type=template&id=6ed69d27&scoped=true&"
import script from "./safeRecord.vue?vue&type=script&lang=js&"
export * from "./safeRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed69d27",
  null
  
)

export default component.exports